export const writePrice = (arg: number | undefined) => {
  if (!arg) {
    return "オープン価格";
  }
  return arg.toLocaleString("ja-JP", {
    style: "currency",
    currency: "JPY",
  });
};
